module.exports = __webpack_public_path__ + "assets/icon_results.cfc5144f.svg";